(function () {
  var section = document.querySelector(
    '[data-section-type="w-sticky-button"]',
  );
  if (!section) return;

  var hasBlocks = section.dataset.hasBlocks === "true";
  var ctaLink = section.querySelector(".sticky-button__cta");
  var ctaTextEl = section.querySelector(".sticky-button__cta-text");
  var ctaSeparator = section.querySelector(".sticky-button__cta-separator");
  var ctaPriceEl = section.querySelector(".sticky-button__cta-price");
  var ctaCompareEl = section.querySelector(".sticky-button__cta-compare-price");
  var ctaArrowEl = section.querySelector(".sticky-button__cta-arrow");
  var reviewsTextEl = section.querySelector(".sticky-button__reviews-text");
  var reassuranceTextEl = section.querySelector(".sticky-button__reassurance-text");

  var configs = [];
  var activeConfigIndex = -1;
  var isSubmitting = false;

  function buildConfigs() {
    var configEls = section.querySelectorAll(".sticky-button__config");
    configs = [];
    for (var i = 0; i < configEls.length; i++) {
      var el = configEls[i];
      var startId = (el.dataset.startSection || "").trim();
      var stopId = (el.dataset.stopSection || "").trim();
      // RA_PT_PDP_4 | Free Travel Mug — Var A adds the gift set that keeps the mug, falling
      // back to the control payload when the block carries no `_abtest` bundle.
      var giftsAttr = el.dataset.gifts;
      if (window.cFreeTravelMugVarA && window.cFreeTravelMugVarA() && el.dataset.giftsAbtest) {
        giftsAttr = el.dataset.giftsAbtest;
      }
      var gifts = [];
      try { gifts = JSON.parse(giftsAttr || "[]"); } catch (e) { gifts = []; }

      configs.push({
        startEl: startId ? document.getElementById(startId) : null,
        stopEl: stopId ? document.getElementById(stopId) : null,
        btnText: el.dataset.btnText || "",
        btnUrl: el.dataset.btnUrl || "",
        showPrice: el.dataset.showPrice === "true",
        priceText: el.dataset.priceText || "",
        comparePrice: el.dataset.comparePrice || "",
        showArrow: el.dataset.showArrow === "true",
        addToCart: el.dataset.addToCart === "true",
        directCheckout: el.dataset.directCheckout === "true",
        variantId: el.dataset.variantId || "",
        sellingPlanId: el.dataset.sellingPlanId || "",
        productUrl: el.dataset.productUrl || "",
        reviewsRating: el.dataset.reviewsRating || "",
        reviewsCount: el.dataset.reviewsCount || "",
        reassuranceText: el.dataset.reassuranceText || "",
        triggerClasses: (el.dataset.triggerClass || "")
          .split(",")
          .map(function (s) { return s.trim(); })
          .filter(Boolean),
        triggerTexts: (el.dataset.triggerText || "")
          .split(",")
          .map(function (s) { return s.trim(); })
          .filter(Boolean),
        triggerElements: [],
        gifts: gifts,
      });
    }
  }

  function buildTriggerElementsForConfig(cfg) {
    cfg.triggerElements = [];

    cfg.triggerClasses.forEach(function (cls) {
      var els = document.querySelectorAll(cls);
      els.forEach(function (el) { cfg.triggerElements.push(el); });
    });

    if (cfg.triggerTexts.length) {
      var walker = document.createTreeWalker(
        document.body,
        NodeFilter.SHOW_TEXT,
        null,
        false,
      );
      while (walker.nextNode()) {
        var node = walker.currentNode;
        var text = node.textContent.trim();
        cfg.triggerTexts.forEach(function (t) {
          if (text.includes(t) && node.parentElement) {
            cfg.triggerElements.push(node.parentElement);
          }
        });
      }
    }
  }

  function isAnyTriggerVisible(cfg) {
    if (!cfg || !cfg.triggerElements || !cfg.triggerElements.length) return false;
    var windowHeight = window.innerHeight;
    for (var i = 0; i < cfg.triggerElements.length; i++) {
      var el = cfg.triggerElements[i];
      if (!el || !el.getBoundingClientRect) continue;
      var rect = el.getBoundingClientRect();
      if (rect.top < windowHeight && rect.bottom > 0) return true;
    }
    return false;
  }

  function applyConfig(cfg) {
    if (!ctaLink) return;
    ctaLink.setAttribute("href", cfg.addToCart ? "#" : cfg.btnUrl);
    if (ctaTextEl) ctaTextEl.textContent = cfg.btnText;

    function keepCurrencyTogether(value) {
      if (!value) return "";
      return String(value).replace(/\s*€/g, "\u00A0€");
    }

    var hasPrice = cfg.showPrice && cfg.priceText;
    if (ctaSeparator) ctaSeparator.style.display = hasPrice ? "" : "none";
    if (ctaPriceEl) {
      ctaPriceEl.style.display = hasPrice ? "" : "none";
      ctaPriceEl.textContent = keepCurrencyTogether(cfg.priceText);
    }
    if (ctaCompareEl) {
      ctaCompareEl.style.display = hasPrice && cfg.comparePrice ? "" : "none";
      ctaCompareEl.textContent = keepCurrencyTogether(cfg.comparePrice);
    }
    if (ctaLink) {
      ctaLink.classList.toggle(
        "sticky-button__cta--has-compare",
        Boolean(hasPrice && cfg.comparePrice),
      );
    }
    if (ctaArrowEl) ctaArrowEl.style.display = cfg.showArrow ? "" : "none";
    if (reviewsTextEl && cfg.reviewsRating && cfg.reviewsCount) {
      reviewsTextEl.textContent = cfg.reviewsRating + "/5 - " + cfg.reviewsCount + " avis";
    }
    if (reassuranceTextEl) {
      reassuranceTextEl.textContent = cfg.reassuranceText || "";
    }
  }

  function handleAddToCart(cfg) {
    if (isSubmitting || !cfg.variantId) return;
    isSubmitting = true;

    var items = [];

    if (cfg.gifts && cfg.gifts.length > 0) {
      cfg.gifts.forEach(function (gift) {
        if (gift.id) {
          items.push({
            id: gift.id,
            quantity: 1,
            properties: {
              "_gift": "true",
              "_parent_variant": cfg.variantId.toString(),
            },
          });
        }
      });
    }

    var mainItem = {
      id: parseInt(cfg.variantId, 10),
      quantity: 1,
    };

    if (cfg.sellingPlanId) {
      mainItem.selling_plan = parseInt(cfg.sellingPlanId, 10);
    }

    items.push(mainItem);

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: items }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Failed to add to cart");

        if (cfg.directCheckout) {
          window.location.href = "/checkout";
        } else {
          var sidecart = document.querySelector("side-cart");
          if (sidecart && typeof sidecart.refreshCartAndOpen === "function") {
            sidecart.refreshCartAndOpen(true);
          }
        }
      })
      .catch(function (error) {
        console.error("Sticky button add to cart error:", error);
      })
      .finally(function () {
        isSubmitting = false;
      });
  }

  function getActiveBlockConfig() {
    var scrollY = window.pageYOffset || document.documentElement.scrollTop;
    var matched = -1;

    for (var i = 0; i < configs.length; i++) {
      var cfg = configs[i];
      var startOk = true;
      var stopOk = true;

      if (cfg.startEl) {
        var startTop = cfg.startEl.getBoundingClientRect().top + scrollY;
        if (scrollY < startTop) startOk = false;
      }

      if (cfg.stopEl) {
        var stopRectTop = cfg.stopEl.getBoundingClientRect().top;
        // Stop as soon as the target section starts entering viewport.
        if (stopRectTop <= window.innerHeight) stopOk = false;
      }

      if (startOk && stopOk) matched = i;
    }

    return matched;
  }

  function checkVisibilityBlocks() {
    var newIndex = getActiveBlockConfig();

    if (newIndex === -1) {
      section.classList.remove("active");
      activeConfigIndex = -1;
      return;
    }

    if (newIndex !== activeConfigIndex) {
      activeConfigIndex = newIndex;
      applyConfig(configs[newIndex]);
      buildTriggerElementsForConfig(configs[newIndex]);
    }

    if (isAnyTriggerVisible(configs[newIndex])) {
      section.classList.remove("active");
      return;
    }

    section.classList.add("active");
  }

  function initCtaClick() {
    if (!ctaLink) return;

    ctaLink.addEventListener("click", function (e) {
      var href = ctaLink.getAttribute("href");

      if (hasBlocks && activeConfigIndex >= 0) {
        var cfg = configs[activeConfigIndex];
        if (cfg.addToCart && cfg.variantId) {
          e.preventDefault();
          handleAddToCart(cfg);
          return;
        }
      }

      if (href && href.charAt(0) === "#") {
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    });
  }

  function init() {
    initCtaClick();

    if (hasBlocks) {
      buildConfigs();
      if (!configs.length) {
        section.classList.add("active");
        return;
      }
      checkVisibilityBlocks();
      window.addEventListener("scroll", checkVisibilityBlocks, { passive: true });
      window.addEventListener("resize", checkVisibilityBlocks, { passive: true });
      return;
    }
    section.classList.add("active");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
